import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
    // overflow: 'auto',
  },
  process: {
    margin: '30px auto 50px auto',

  },
  calendarInstruction: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1a1a1a',
    margin: '16px 0 8px',
    letterSpacing: '0.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      margin: '12px 0 6px',
    },
  },
  specBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    color: '#6F7878',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  specBox_spec01: {
    float: 'left',
    marginTop: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      lineHeight: '21px',
    },
  },
  specBox_fontColorRed: {
    color: '#CD0021',
    fontSize: '16px',
    lineHeight: '24px',
  },
  specBox_spec02: {
    width: '85%',
    padding: '0.5em',
    border: 'solid 1px #999999',
    fontSize: '13px',
    lineHeight: '19px',
    letterSpacing: '0.8px',
    margin: '0.5em 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '11px',
      lineHeight: '17px',
      letterSpacing: '0.28px',
    },
  },
  fontSizeNote: {
    fontSize: '14px',
    lineHeight: '21px',
    color: '#6F7878',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0.28px',
    },
  },
  boxWarning: {
    padding: '0.6em 1em',
    border: 'solid 1px #D0111B',
    margin: '0.8em 0 2.5em',
  },
  boxWarning_fontColorRed: {
    color: '#CD0021',
    fontSize: '18px',
    lineHeight: '27px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  boxWarning_item: {
    fontSize: '0.87em',
    color: '#6f7878',
    lineHeight: '21px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0.28px',
    },
  },
  box_belt: {
    marginBottom: '0.6em',
    padding: '0.1em 0.6em',
    backgroundColor: '#F4F5F5',
    borderLeft: 'solid 10px #CD0021',
    color: '#000',
    fontSize: '26px',
    lineHeight: '39px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '17px',
      lineHeight: '25px',
      letterSpacing: '0.28px',
    },
  },
  serviceItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: '28px',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  linkCss: {
    //
  },
  disabledCursor: {
    // cursor: 'default',
    color: '#6f7878 !important',
  },
}));

export default useStyles;
